import apiClient from './axiosInstanceStock';

export const getStockByVesselId = async (vesselId) => {
  if (!vesselId) {
    throw new Error('Stock ID is required');
  }
  return await apiClient.get(`/stockdetails/vessel/${vesselId}`);
};
